import { freeSpinStates } from '../../constants';

const getBonusExpireTime = ({ state, expireTime, maxActivationTime }) =>
  state === freeSpinStates.FREESPIN_RELEASED ? expireTime : maxActivationTime;

export default getBonusExpireTime;
